import ConfigStore = require('configstore')
import { PROJECT_NAME } from './config'

export default new ConfigStore(PROJECT_NAME)
